import { render, staticRenderFns } from "./PointBitcashComplete.vue?vue&type=template&id=d66295de"
import script from "./PointBitcashComplete.vue?vue&type=script&lang=js"
export * from "./PointBitcashComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports